import type { InventoryDetail, InventorySummary } from '@gozoki/api-types'
import { gozokiApi, gozokiApiWithAuth } from '../gozokiApi'

export const fetchInventories = async () => {
  const response = await gozokiApi.get<InventorySummary[]>('/inventories/')
  return response.data
}

export const fetchInventory = async (id: number) => {
  const response = await gozokiApiWithAuth.get<InventoryDetail>(`/inventories/${id}`)
  return response.data
}

export const fetchStoreInventories = async (id: number) => {
  const response = await gozokiApiWithAuth.get<InventorySummary[]>(`/stores/${id}/inventories`)
  return response.data
}

export const updateUnScannableProducts = async (data: {
  id: number
  productRef: string
  count: number
}) => {
  const { id, productRef, count } = data
  return gozokiApiWithAuth.post<InventoryDetail>(`/inventories/${id}/unscannable-products`, {
    count,
    productRef,
  })
}

export const updateInventoryDescription = async (data: {
  id: number
  label: string
  comment: string
}) => {
  const { id, label, comment } = data
  return gozokiApiWithAuth.post(`inventories/${id}/description`, { comment, label })
}

export const updateInventoryStatus = async (data: {
  id: number
  status: 'pending' | 'validated' | 'canceled'
}) => {
  const { id, status } = data
  return gozokiApiWithAuth.post(`inventories/${id}/status`, { status })
}

export const updateInventoryFinishedStatus = async (data: { id: number; isFinished: boolean }) => {
  const { id, isFinished } = data
  return gozokiApiWithAuth.post(`inventories/${id}/finished-status`, { isFinished })
}
